export default {
  // 生产环境配置
  //   baseUrl: process.env.NODE_ENV == 'development' ? 'http://localhost:9555' : 'http://36.138.71.178:8555',
  // 测试环境配置
  // baseUrl: 'https://qcwlapi.zhidiansaas.com',
  //   baseUrl: 'https://api.v2.scqsng.org.cn',


  // 四川省青少年宫
  // baseUrl: 'https://api.v2.scqsng.org.cn',
  // baseUrl: 'https://testapi.v2.scqsng.org.cn',


  // 四川省青少年宫-测试环境
  // baseUrl: 'https://testapi.v2.scqsng.org.cn'
  // baseUrl: 'http://8.137.112.148:30071'

  // 青神青少年宫
  baseUrl: 'https://qsadmin.qsqsng.org.cn/apiv2'
  // baseUrl: 'http://192.168.101.55:30010'


  // 四川省青少年宫
  // baseUrl: 'https://scsqsngtestapi.zhidiansaas.com'
  // baseUrl: 'http://192.168.101.55:30010'
  // 开发外网地址
  // baseUrl: 'https://devapi.zhidiansaas.com'
  // 开发环境
  // baseUrl: 'http://192.168.101.174:8555'
  // 开发环境
  // baseUrl: 'http://localhost:7555'
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js